import { SizableText, type SizableTextProps } from 'tamagui';

interface FieldTitleProps
  extends Partial<Pick<SizableTextProps, 'size' | 'color' | 'fontFamily'>> {
  label?: string;
  required?: boolean;
  requiredColor?: SizableTextProps['color'];
  requiredFontFamily?: SizableTextProps['fontFamily'];
}

const defaultSize: FieldTitleProps['size'] = '$2';
const defaultColor: FieldTitleProps['color'] = '$color';
const defaultRequiredColor: FieldTitleProps['requiredColor'] = '$brand';

export const FieldTitle = ({
  label,
  required = false,
  size = defaultSize,
  color = defaultColor,
  fontFamily = '$bold',
  requiredColor = defaultRequiredColor,
  requiredFontFamily,
}: FieldTitleProps): React.ReactElement | null => {
  if (!label) {
    return null;
  }

  const appliedRequiredFont = requiredFontFamily ?? fontFamily ?? '$bold';

  return (
    <SizableText size={size} color={color} fontFamily={fontFamily}>
      {label}
      {required && (
        <SizableText
          size={size}
          color={requiredColor}
          fontFamily={appliedRequiredFont}
        >
          {' '}
          *
        </SizableText>
      )}
    </SizableText>
  );
};
